module.exports = __webpack_public_path__ + "img/contact.b3daae5d.png";